<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <h4>Ruedas</h4>
      <div class="row">
        <div class="col-md-6">
          <!-- RUEDA DELANTERA INZQUIERDA -->
          <div v-if="isFieldVisible('photo_wheel_front_left_file')" class="col-md-8 mt-3">
            <div>
              <div class="form-group bordered">
                <label for="photo_wheel_front_left_file" class="form-label text-left">{{ getFieldDescription('photo_wheel_front_left_file') }}</label>
              </div>
              <div>
                <div>
                  <div @click="openCamera('photo_wheel_front_left_file')" class="btn btn-custom">
                    <i class="bi bi-camera-fill"></i> Tomar fotografía
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    capture="camera"
                    class="form-control inputfile"
                    :name="'photo_wheel_front_left_file'"
                    :id="'photo_wheel_front_left_file'"
                    style="display: none;"
                    @change="onFileChange('photo_wheel_front_left_file')"
                  />
                </div>
              </div>
              <div class="btn tbn-block btn-custom mt-3" v-if="photo_wheel_front_left_file" @click="openImageModal(photo_wheel_front_left_file)">Ver Imagen</div>
              </div>
            </div>
          <!-- CONDICION -->
          <div v-if="isFieldVisible('wheel_front_left_condition_id')" class="col-md-8 mt-3">
            <div class="form-group bordered">
              <label for="wheel_front_left_condition_id" class="form-label text-left">
                {{ getFieldDescription('wheel_front_left_condition_id') }}
              </label>
              <select
                class="form-control select-custom"
                :value="wheel_front_left_condition_id"
                @change="onConditionChange('wheel_front_left_condition_id', $event.target.value)"
                required="required"
              >
                <option value="" disabled>-- Selecciona una Condicion --</option>
                <option v-for="wheelCondition in wheelConditions" :key="wheelCondition.id" :value="wheelCondition.id">
                  {{ wheelCondition.name }}
                </option>
              </select>
            </div>
          </div>
          <!-- MATERIAL -->
          <div v-if="isFieldVisible('wheel_front_left_material_id')" class="col-md-8 mt-3">
            <div class="form-group bordered">
              <label for="wheel_front_left_material_id" class="form-label text-left">
                {{ getFieldDescription('wheel_front_left_material_id') }}
              </label>
              <select
                class="form-control select-custom"
                :value="wheel_front_left_material_id"
                @change="onMaterialChange('wheel_front_left_material_id', $event.target.value)"
                required="required"
              > 
                <option value="" disabled>-- Selecciona un Material --</option>
                <option v-for="wheelMaterial in wheelMaterials" :key="wheelMaterial.id" :value="wheelMaterial.id">
                  {{ wheelMaterial.name }}
                </option>
              </select>
            </div>
          </div>
          <hr class="custom-hr col-md-12+" />
        </div>
        <div class="col-md-6">
          <!-- RUEDA DELANTERA DERECHA -->
          <div v-if="isFieldVisible('photo_wheel_front_right_file')" class="col-md-8 mt-3">
            <div>
              <div class="form-group bordered">
                <label for="photo_wheel_front_right_file" class="form-label text-left">{{ getFieldDescription('photo_wheel_front_right_file') }}</label>
              </div>
              <div>
                <div>
                <div @click="openCamera('photo_wheel_front_right_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_wheel_front_right_file'"
                  :id="'photo_wheel_front_right_file'"
                  style="display: none;"
                  @change="onFileChange('photo_wheel_front_right_file')"
                />
              </div>
              </div>
              <div class="btn btn-block btn-custom mt-3" v-if="photo_wheel_front_right_file" @click="openImageModal(photo_wheel_front_right_file)">Ver Imagen</div>
            </div>
          </div>
          <!-- CONDICION -->
          <div v-if="isFieldVisible('wheel_front_right_condition_id')" class="col-md-8 mt-3">
            <div class="form-group bordered">
              <label for="wheel_front_right_condition_id" class="form-label text-left">
                {{ getFieldDescription('wheel_front_right_condition_id') }}
              </label>
              <select 
                class="form-control select-custom"
                :value="wheel_front_right_condition_id" 
                @change="onConditionChange('wheel_front_right_condition_id', $event.target.value)"
                required="required"
                >
                  <option value="" disabled>-- Selecciona una Condicion --</option>
                  <option v-for="wheelCondition in wheelConditions" :key="wheelCondition.id" :value="wheelCondition.id">
                    {{ wheelCondition.name }}
                  </option>
                </select>
            </div>
          </div>
           <!-- MATERIAL -->
           <div v-if="isFieldVisible('wheel_front_right_material_id')" class="col-md-8 mt-3">
            <div class="form-group bordered">
              <label for="wheel_front_right_material_id" class="form-label text-left">
                {{ getFieldDescription('wheel_front_right_material_id') }}
              </label>
              <select
                class="form-control select-custom"
                :value="wheel_front_right_material_id"
                @change="onMaterialChange('wheel_front_right_material_id', $event.target.value)"
                required="required"
              >
                <option value="" disabled>-- Selecciona un Material --</option>
                <option v-for="wheelMaterial in wheelMaterials" :key="wheelMaterial.id" :value="wheelMaterial.id">
                  {{ wheelMaterial.name }}
                </option>
              </select>
            </div>
            
          </div>
          <hr class="custom-hr col-md-12" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <!-- RUEDA TRASERA IZQUIERDA -->
          <div v-if="isFieldVisible('photo_wheel_back_left_file')" class="col-md-8 mt-3">
            <div>
              <div class="form-group bordered">
                <label for="photo_wheel_back_left_file" class="form-label text-left">{{ getFieldDescription('photo_wheel_back_left_file') }}</label>
              </div>
              <div>
                <div>
                <div @click="openCamera('photo_wheel_back_left_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_wheel_back_left_file'"
                  :id="'photo_wheel_back_left_file'"
                  style="display: none;"
                  @change="onFileChange('photo_wheel_back_left_file')"
                />
              </div>
              </div>
              <div class="btn tbn-block btn-custom mt-3" v-if="photo_wheel_back_left_file" @click="openImageModal(photo_wheel_back_left_file)">Ver Imagen</div>
            </div>
          </div>
           <!-- CONDICION -->
           <div v-if="isFieldVisible('wheel_back_left_condition_id')" class="col-md-8 mt-3">
            <div class="form-group bordered">
              <label for="wheel_back_left_condition_id" class="form-label text-left">
                {{ getFieldDescription('wheel_back_left_condition_id') }}
              </label>
               <select class="form-control select-custom"
                :value="wheel_back_left_condition_id" 
      
                @change="onConditionChange('wheel_back_left_condition_id', $event.target.value)"
                required="required"
                >
                  <option value="" disabled>-- Selecciona una Condicion --</option>
                  <option v-for="wheelCondition in wheelConditions" :key="wheelCondition.id" :value="wheelCondition.id">
                    {{ wheelCondition.name }}
                  </option>
                </select>
            </div>
          </div>
           <!-- MATERIAL -->
           <div v-if="isFieldVisible('wheel_back_right_material_id')" class="col-md-8 mt-3">
            <div class="form-group bordered">
              <label for="wheel_back_right_material_id" class="form-label text-left">
                {{ getFieldDescription('wheel_back_right_material_id') }}
              </label>
              <select
                class="form-control select-custom"
                :value="wheel_back_right_material_id"
                @change="onMaterialChange('wheel_back_right_material_id', $event.target.value)"
                required="required"
              >
                <option value="" disabled>-- Selecciona un Material --</option>
                <option v-for="wheelMaterial in wheelMaterials" :key="wheelMaterial.id" :value="wheelMaterial.id">
                  {{ wheelMaterial.name }}
                </option>
              </select>
            </div>
          </div>
          <hr class="custom-hr col-md-12" />
        </div>
        <div class="col-md-6">
          <!-- RUEDA TRASERA DERECHA -->
          <div v-if="isFieldVisible('photo_wheel_back_right_file')" class="col-md-8 mt-3">
            <div>
              <div class="form-group bordered">
                <label for="photo_wheel_back_right_file" class="form-label text-left">{{ getFieldDescription('photo_wheel_back_right_file') }}</label>
              </div>
              <div>
                <div>
                <div @click="openCamera('photo_wheel_back_right_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_wheel_back_right_file'"
                  :id="'photo_wheel_back_right_file'"
                  style="display: none;"
                  @change="onFileChange('photo_wheel_back_right_file')"
                />
              </div>
              </div>
              <div class="btn btn-block btn-custom mt-3" v-if="photo_wheel_back_right_file" @click="openImageModal(photo_wheel_back_right_file)">Ver Imagen</div>
            </div>
          </div>
           <!-- CONDICION -->
           <div v-if="isFieldVisible('wheel_back_right_condition_id')" class="col-md-8 mt-3">
            <div class="form-group bordered">
              <label for="wheel_back_right_condition_id" class="form-label text-left">
                {{ getFieldDescription('wheel_back_right_condition_id') }}
              </label>
               <select class="form-control select-custom"
                :value="wheel_back_right_condition_id" 
      
                @change="onConditionChange('wheel_back_right_condition_id', $event.target.value)"
                required="required"
                >
                  <option value="" disabled>-- Selecciona una Condicion --</option>
                  <option v-for="wheelCondition in wheelConditions" :key="wheelCondition.id" :value="wheelCondition.id">
                    {{ wheelCondition.name }}
                  </option>
                </select>
            </div>
          </div>
           <!-- MATERIAL -->
           <div v-if="isFieldVisible('wheel_back_left_material_id')" class="col-md-8 mt-3">
            <div class="form-group bordered">
              <label for="wheel_back_left_material_id" class="form-label text-left">
                {{ getFieldDescription('wheel_back_left_material_id') }}
              </label>
              <select
                class="form-control select-custom"
                :value="wheel_back_left_material_id"
                @change="onMaterialChange('wheel_back_left_material_id', $event.target.value)"
                required="required"
              >
                <option value="" disabled>-- Selecciona un Material --</option>
                <option v-for="wheelMaterial in wheelMaterials" :key="wheelMaterial.id" :value="wheelMaterial.id">
                  {{ wheelMaterial.name }}
                </option>
              </select>
            </div>
          </div>
          <hr class="custom-hr col-md-12" />
        </div>
  
        <div class="col-md-6">
          <!-- RUEDAS DE AUXILIO -->
          <div v-if="isFieldVisible('photo_wheel_extra_file')" class="col-md-8 mt-3">
            <div>
              <div class="form-group bordered">
                <label for="photo_wheel_extra_file" class="form-label text-left">{{ getFieldDescription('photo_wheel_extra_file') }}</label>
              </div>
              <div>
                <div>
                <div @click="openCamera('photo_wheel_extra_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_wheel_extra_file'"
                  :id="'photo_wheel_extra_file'"
                  style="display: none;"
                  @change="onFileChange('photo_wheel_extra_file')"
                />
              </div>
              </div>
              <div class="btn tbn-block btn-custom mt-3" v-if="photo_wheel_extra_file" @click="openImageModal(photo_wheel_extra_file)">Ver Imagen</div>
            </div>
          </div>
           <!-- CONDICION -->
           <div v-if="isFieldVisible('wheel_extra_condition_id')" class="col-md-8 mt-3">
            <div class="form-group bordered">
              <label for="wheel_extra_condition_id" class="form-label text-left">
                {{ getFieldDescription('wheel_extra_condition_id') }}
              </label>
               <select class="form-control select-custom"
                :value="wheel_extra_condition_id" 
                @change="onConditionChange('wheel_extra_condition_id', $event.target.value)"
                required="required"
                >
                  <option value="" disabled>-- Selecciona una Condicion --</option>
                  <option v-for="wheelCondition in wheelConditions" :key="wheelCondition.id" :value="wheelCondition.id">
                    {{ wheelCondition.name }}
                  </option>
                </select>
            </div>
          </div>
           <!-- MATERIAL -->
           <div v-if="isFieldVisible('wheel_extra_material_id')" class="col-md-8 mt-3">
            <div class="form-group bordered">
              <label for="wheel_extra_material_id" class="form-label text-left">
                {{ getFieldDescription('wheel_extra_material_id') }}
              </label>
              <select
                class="form-control select-custom"
                :value="wheel_extra_material_id"
                @change="onMaterialChange('wheel_extra_material_id', $event.target.value)"
                required="required"
              >
                <option value="" disabled>-- Selecciona un Material --</option>
                <option v-for="wheelMaterial in wheelMaterials" :key="wheelMaterial.id" :value="wheelMaterial.id">
                  {{ wheelMaterial.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <hr class="custom-hr col-md-12 mt-4" />
    </div>
  </div>
    
  <!-- MODAL -->
  <ShowImagesModal
  :modalId="'imageModalPhotoWheel'"
  :currentImage="currentImage"
  :currentImageName="currentImageName"
  />
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import ShowImagesModal from '../../modals/ShowImages';
import ImageCompressor from 'image-compressor.js'; 
import { rotateImageIfNeeded } from '../../../Utils/imageUtils';  

export default {
  name: 'FormPhotoWheel',
  props: {
    data: Object,
  },
  components: {
    ShowImagesModal,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const wheelConditions = ref(props.data.dataWheelConditions);
    const wheelMaterials = ref(props.data.dataWheelMaterials);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const currentImage = ref(null);
    const currentImageName = ref('');

    const photo_wheel_front_left_file = ref(null);
    const photo_wheel_front_right_file = ref(null);
    const photo_wheel_back_left_file = ref(null);
    const photo_wheel_back_right_file = ref(null);
    const photo_wheel_extra_file = ref(null);
    const wheel_front_left_condition_id = ref(null);
    const wheel_front_left_material_id = ref(null);
    const wheel_front_right_condition_id = ref(null);
    const wheel_front_right_material_id = ref(null);
    const wheel_back_left_condition_id = ref(null);
    const wheel_back_left_material_id = ref(null);
    const wheel_back_right_condition_id = ref(null);
    const wheel_back_right_material_id = ref(null);
    const wheel_extra_condition_id = ref(null);
    const wheel_extra_material_id = ref(null);

    const formData = reactive({
      photo_wheel_front_left_id: null,
      photo_wheel_front_right_id: null,
      photo_wheel_back_left_id: null,
      photo_wheel_back_right_id: null,
      photo_wheel_extra_id: null,
      wheel_front_left_condition_id: null,
      wheel_front_left_material_id: null,
      wheel_front_right_condition_id: null,
      wheel_front_right_material_id: null,
      wheel_back_right_condition_id: null,
      wheel_back_right_material_id: null,
      wheel_back_left_condition_id: null,
      wheel_back_left_material_id: null,
      wheel_extra_condition_id: null,
      wheel_extra_material_id: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.photo_wheel_front_left_file ||
            dataCompany.value.photo_wheel_front_right_file ||
            dataCompany.value.photo_wheel_back_left_file ||
            dataCompany.value.photo_wheel_back_right_file ||
            dataCompany.value.photo_wheel_extra_file ||
            dataCompany.value.wheel_front_left_condition_id ||
            dataCompany.value.wheel_front_left_material_id ||
            dataCompany.value.wheel_front_right_condition_id ||
            dataCompany.value.wheel_front_right_material_id ||
            dataCompany.value.wheel_back_left_condition_id ||
            dataCompany.value.wheel_back_left_material_id ||
            dataCompany.value.wheel_back_right_condition_id ||
            dataCompany.value.wheel_back_right_material_id ||
            dataCompany.value.wheel_extra_condition_id ||
            dataCompany.value.wheel_extra_material_id)
        );
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const openImageModal = (imageFile) => {
      currentImage.value = URL.createObjectURL(imageFile);
      currentImageName.value = imageFile.name;
      $('#imageModalPhotoWheel').modal('show');
    };

    const onFileChange = async (fieldName) => {
      const fileFields = {
        photo_wheel_front_left_file: photo_wheel_front_left_file,
        photo_wheel_front_right_file: photo_wheel_front_right_file,
        photo_wheel_back_left_file: photo_wheel_back_left_file,
        photo_wheel_back_right_file: photo_wheel_back_right_file,
        photo_wheel_extra_file: photo_wheel_extra_file,
      };

      const fileInput = document.getElementById(fieldName);

      try {
        const rotatedFile = await rotateImageIfNeeded(fileInput.files[0], 90);
        const compressedFile = await compressImage(rotatedFile);
        fileFields[fieldName].value = compressedFile;
        emitFieldChanged();
      } catch (error) {
        console.error('Error al comprimir la imagen:', error);
      }
    };

    const compressImage = (file) => {
      return new Promise((resolve, reject) => {
        const compressor = new ImageCompressor();
        compressor.compress(file, {
          maxWidth: 800,
          maxHeight: 600,
          quality: 1,
          mimeType: 'image/jpeg',
          success(result) {
            resolve(result);
          },
          error(error) {
            reject(error);
          },
        });
      });
    };

    const onConditionChange = (fieldName, value) => {
      if (fieldName === 'wheel_front_left_condition_id') {
        wheel_front_left_condition_id.value = value;
      } else if (fieldName === 'wheel_front_right_condition_id') {
        wheel_front_right_condition_id.value = value;
      } else if (fieldName === 'wheel_back_right_condition_id') {
        wheel_back_right_condition_id.value = value;
      } else if (fieldName === 'wheel_back_left_condition_id') {
        wheel_back_left_condition_id.value = value;
      } else if (fieldName === 'wheel_extra_condition_id') {
        wheel_extra_condition_id.value = value;
      }
      emitFieldChanged();
    };

    const onMaterialChange = (fieldName, value) => {
      if (fieldName === 'wheel_front_left_material_id') {
        wheel_front_left_material_id.value = value;
      } else if (fieldName === 'wheel_front_right_material_id') {
        wheel_front_right_material_id.value = value;
      } else if (fieldName === 'wheel_back_right_material_id') {
        wheel_back_right_material_id.value = value;
      } else if (fieldName === 'wheel_back_left_material_id') {
        wheel_back_left_material_id.value = value;
      } else if (fieldName === 'wheel_extra_material_id') {
        wheel_extra_material_id.value = value;
      }
      emitFieldChanged();
    };

    const emitFieldChanged = () => {
      const formFields = {
        photo_wheel_front_left_id: photo_wheel_front_left_file.value,
        photo_wheel_front_right_id: photo_wheel_front_right_file.value,
        photo_wheel_back_left_id: photo_wheel_back_left_file.value,
        photo_wheel_back_right_id: photo_wheel_back_right_file.value,
        photo_wheel_extra_id: photo_wheel_extra_file.value,
      };
      const formFieldsWheel = {
        wheel_front_left_condition_id: wheel_front_left_condition_id.value,
        wheel_front_right_condition_id: wheel_front_right_condition_id.value,
        wheel_back_right_condition_id: wheel_back_left_condition_id.value,
        wheel_back_left_condition_id: wheel_back_right_condition_id.value,
        wheel_extra_condition_id: wheel_extra_condition_id.value,
        wheel_front_left_material_id: wheel_front_left_material_id.value,
        wheel_front_right_material_id: wheel_front_right_material_id.value,
        wheel_back_right_material_id: wheel_back_left_material_id.value,
        wheel_back_left_material_id: wheel_back_right_material_id.value,
        wheel_extra_material_id: wheel_extra_material_id.value,
      };

      const validFields = {};
      for (const [key, value] of Object.entries(formFields)) {
        if (dataCompany.value && dataCompany.value[key.replace('_id', '_file')]) {
          validFields[key] = value;
        }
      }

      formData.value = validFields;
      emit('formDataChanged', formData.value);
      emit('formDataChanged', formFieldsWheel);
    };

    const openCamera = async (fieldName) => {
      try {
        const inputElement = document.getElementById(fieldName);
        inputElement.addEventListener('change', async () => {
          const file = inputElement.files[0];
          if (file) {
            // Llama a la función onFileChange con el nombre del campo y el archivo seleccionado
            await onFileChange(fieldName, file);
          }
        });
        inputElement.click();
      } catch (error) {
        console.error('Error al capturar la foto:', error);
      }
    };


    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      openImageModal,
      onFileChange,
      currentImage,
      currentImageName,
      emitFieldChanged,
      onConditionChange,
      onMaterialChange,
      formData,
      wheelConditions,
      wheelMaterials,
      photo_wheel_front_left_file,
      wheel_front_left_condition_id,
      wheel_front_left_material_id,
      photo_wheel_front_right_file,
      wheel_front_right_condition_id,
      wheel_front_right_material_id,
      photo_wheel_back_left_file,
      wheel_back_left_condition_id,
      wheel_back_left_material_id,
      photo_wheel_back_right_file,
      wheel_back_right_condition_id,
      wheel_back_right_material_id,
      photo_wheel_extra_file,
      wheel_extra_condition_id,
      wheel_extra_material_id,
      openCamera,
    };
  },
};
</script>

